export default "__VITE_ASSET__BVyofyD5__"